import Utils from "../../../../../shared/utils";

export const BELL_ANIMATION = Utils.buildNewsletterLink("animations/bell.svg")